import React, { useState } from 'react';
import { ChevronDown, ChevronRight, Settings } from 'lucide-react';
import { getOrderTypeColor } from '../../../tasks/taskCardUtils';
import {
  ACTOR_TYPE_SYSTEM,
  formatActivityTimestamp,
  getActorInitials,
  getActorLabel
} from './activityUtils';

const COLORED_CHIP_LABELS = new Set(['Lien Search', 'Estoppel', 'Survey']);

const getChipStyle = chipLabel => {
  if (!COLORED_CHIP_LABELS.has(chipLabel)) {
    return undefined;
  }

  return {
    background: getOrderTypeColor(chipLabel),
    color: '#fff'
  };
};

const ActivityRow = ({ item, currentUser }) => {
  const actor = item?.actors?.[0];
  const display = item?.display || {};
  const isSystem = actor?.type === ACTOR_TYPE_SYSTEM;
  const initials = getActorInitials(actor, currentUser);
  const statusChange = display.statusChange;
  const fieldChanges = display.fieldChanges || [];
  const [showFieldChanges, setShowFieldChanges] = useState(false);
  const fieldChangeLabel = fieldChanges.length === 1 ? '1 field changed' : `${fieldChanges.length} fields changed`;
  const actorLabel = getActorLabel(actor, currentUser);
  const actionText = display.actionText || item.summary || 'updated activity';
  const chipLabel = display.chipLabel || 'Activity';
  const chipStyle = getChipStyle(chipLabel);

  return (
    <div className="activity-row">
      <span className={`activity-row-avatar${isSystem ? ' system' : ''}`} aria-hidden="true">
        {isSystem ? <Settings size={14} /> : initials}
      </span>
      <div className="activity-row-content">
        <div className="activity-row-header">
          <div className="activity-row-sentence">
            <span className="activity-row-actor">{actorLabel}</span> {actionText}
          </div>
          <span className="activity-row-chip" style={chipStyle}>
            {chipLabel}
          </span>
        </div>
        <div className="activity-row-meta">{formatActivityTimestamp(item.createdAt)}</div>
        {statusChange && (
          <div className="activity-row-status-change">
            {statusChange.from} → {statusChange.to}
          </div>
        )}
        {fieldChanges.length > 0 && (
          <div className="activity-row-field-changes">
            <button
              type="button"
              className="activity-row-field-changes-toggle"
              onClick={() => setShowFieldChanges(previous => !previous)}
              aria-expanded={showFieldChanges}
            >
              {showFieldChanges ? (
                <ChevronDown size={14} strokeWidth={2.5} aria-hidden="true" />
              ) : (
                <ChevronRight size={14} strokeWidth={2.5} aria-hidden="true" />
              )}
              <span>{fieldChangeLabel}</span>
            </button>
            {showFieldChanges && (
              <div className="activity-row-field-changes-list">
                {fieldChanges.map(change => (
                  <div key={change.field} className="activity-row-field-change">
                    <span className="activity-row-field-name">{change.fieldLabel}:</span>{' '}
                    <span className="activity-row-field-value" title={change.from}>
                      {change.from}
                    </span>
                    <span className="activity-row-field-arrow"> → </span>
                    <span className="activity-row-field-value" title={change.to}>
                      {change.to}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ActivityRow;
